import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RepatriationsTransactionsEditDialog from './RepatriationsTransactionsEditDialog';

class RepatriationsTransactionsEdit extends Component {
  render() {
    return (
      <div>
        <RepatriationsTransactionsEditDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

RepatriationsTransactionsEdit.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default RepatriationsTransactionsEdit;
